import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    root: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        height:"100%"
    }
}